//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const AverageHouseholdIncome = ({ count }: { count: string | number }) => {
  return <StatCard title='Average Household Income' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default AverageHouseholdIncome;
